import {
  IFilingSettings1099,
  IFilingSettings1099ByYear
} from "@wingspanhq/payments/dist/interfaces";
import { TaxFormType } from "@wingspanhq/payments/dist/interfaces/taxForm";
import React from "react";
import { useUserId } from "../../../../query/hooks/helpers";
import { usePayrollSettings } from "../../../../query/payments/queries";
import { DataView } from "../../../../shared/components/DataView";
import { MISCDescription } from "../../components/MISCDescription";
import { selectorTypeFormLabel } from "../../selectors/selectorTypeFormLabel";
import { useCurrentTaxFilingYear } from "../../utils/useCurrentTaxFilingYear";
import { WSInfoBox, WSList } from "@wingspanhq/fe-component-library";

export const FormType: React.FC<{}> = () => {
  const userId = useUserId();
  const currentYear = useCurrentTaxFilingYear();
  const queryPayrollSettings = usePayrollSettings(userId);

  const filingSettings =
    queryPayrollSettings.data?.calculationSettings1099?.filingSettings?.[
      `${currentYear}` as keyof IFilingSettings1099<IFilingSettings1099ByYear>
    ];
  const taxFormType = filingSettings?.taxFormType;

  return (
    <DataView
      loading={queryPayrollSettings.isLoading}
      title="Form type"
      header={{
        label: {
          text: "Form type",
          helperText:
            "Once set, the form type will be locked in for the tax year."
        }
      }}
      data={[
        {
          label: "1099 type",
          value: selectorTypeFormLabel(taxFormType)
        }
      ]}
    >
      <WSList gap="M">
        {taxFormType === TaxFormType.Form1099Misc ? <MISCDescription /> : null}
        <WSInfoBox theme="info">
          You can change this each year. All other settings apply to your
          account.
        </WSInfoBox>
      </WSList>
    </DataView>
  );
};
